import React from "react";
import {css, useTheme} from "@emotion/react";

import {flex, flexDirection, p, ph} from "@pg-design/helpers-css";
import {BrandCheckboxCheckedIcon} from "@pg-design/icons-module";
import {Text} from "@pg-design/text-module";

export const OfferChatBotThankYouBox = () => {
    const theme = useTheme();

    return (
        <div css={[flex("center", "center"), flexDirection("column")]}>
            <div css={iconWrapperStyle}>
                <BrandCheckboxCheckedIcon size="7.2" wrapperSize="7.2" wrapperColor={theme.colors.primary} />
            </div>
            <Text variant="body_copy_2" align="center" css={ph(2)}>
                Dziękujemy! Od tej chwili będziesz otrzymywać powiadomienia o nowych ofertach.
            </Text>
        </div>
    );
};

const iconWrapperStyle = css`
    ${p(4)};
`;
import React from "react";
import {css, useTheme} from "@emotion/react";

import {flex, flexDirection, p, ph} from "@pg-design/helpers-css";
import {BrandCheckboxCheckedIcon} from "@pg-design/icons-module";
import {Text} from "@pg-design/text-module";

export const OfferChatBotThankYouBox = () => {
    const theme = useTheme();

    return (
        <div css={[flex("center", "center"), flexDirection("column")]}>
            <div css={iconWrapperStyle}>
                <BrandCheckboxCheckedIcon size="7.2" wrapperSize="7.2" wrapperColor={theme.colors.primary} />
            </div>
            <Text variant="body_copy_2" align="center" css={ph(2)}>
                Dziękujemy! Od tej chwili będziesz otrzymywać powiadomienia o nowych ofertach.
            </Text>
        </div>
    );
};

const iconWrapperStyle = css`
    ${p(4)};
`;
